// Monetization copy — benefit-first tone, never "fee/charge/subscribe/buy" as headline or button.
// Full, tone-matched copy is provided for all 10 supported languages. All amounts render as
// absolute ₹ values (never bare percentages). Placeholders like {amount}/{views}/{cover} are
// preserved across every language.
import { useEffect, useState, useCallback } from "react";
import api from "./lib/api";

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

const COPY = {
  // A. Plans
  plan_title: {
    en: "Unlock more for your property", hi: "अपनी प्रॉपर्टी के लिए और अनलॉक करें",
    mr: "तुमच्या प्रॉपर्टीसाठी अधिक अनलॉक करा", bn: "আপনার সম্পত্তির জন্য আরও আনলক করুন",
    ta: "உங்கள் சொத்துக்கு மேலும் திறக்கவும்", te: "మీ ఆస్తికి మరిన్ని అన్‌లాక్ చేయండి",
    kn: "ನಿಮ್ಮ ಆಸ್ತಿಗೆ ಇನ್ನಷ್ಟು ಅನ್‌ಲಾಕ್ ಮಾಡಿ", gu: "તમારી પ્રોપર્ટી માટે વધુ અનલૉક કરો",
    ml: "നിങ്ങളുടെ പ്രോപ്പർട്ടിക്ക് കൂടുതൽ അൺലോക്ക് ചെയ്യൂ", pa: "ਆਪਣੀ ਪ੍ਰਾਪਰਟੀ ਲਈ ਹੋਰ ਅਨਲਾਕ ਕਰੋ",
  },
  plan_cta: {
    en: "See what's included", hi: "देखें क्या-क्या शामिल है",
    mr: "काय समाविष्ट आहे ते पाहा", bn: "কী কী অন্তর্ভুক্ত দেখুন",
    ta: "என்ன அடங்கும் என்று பாருங்கள்", te: "ఏమేమి ఉన్నాయో చూడండి",
    kn: "ಏನೆಲ್ಲಾ ಸೇರಿದೆ ನೋಡಿ", gu: "શું શું સામેલ છે તે જુઓ",
    ml: "എന്തൊക്കെ ഉൾപ്പെടുന്നു എന്ന് കാണൂ", pa: "ਵੇਖੋ ਕੀ-ਕੀ ਸ਼ਾਮਲ ਹੈ",
  },
  plan_gate_police: {
    en: "Police-verification filing is part of the Pro plan — want to see what else is included?",
    hi: "पुलिस सत्यापन फाइलिंग Pro प्लान का हिस्सा है — देखें और क्या शामिल है?",
    mr: "पोलिस पडताळणी फाइलिंग Pro प्लॅनचा भाग आहे — अजून काय समाविष्ट आहे ते पाहायचे?",
    bn: "পুলিশ যাচাই ফাইলিং Pro প্ল্যানের অংশ — আর কী অন্তর্ভুক্ত দেখবেন?",
    ta: "போலீஸ் சரிபார்ப்பு தாக்கல் Pro திட்டத்தின் பகுதி — வேறு என்ன அடங்கும் என்று பார்க்கவா?",
    te: "పోలీస్ ధృవీకరణ ఫైలింగ్ Pro ప్లాన్‌లో భాగం — ఇంకా ఏమి ఉందో చూడాలా?",
    kn: "ಪೊಲೀಸ್ ಪರಿಶೀಲನೆ ಫೈಲಿಂಗ್ Pro ಪ್ಲಾನ್‌ನ ಭಾಗ — ಇನ್ನೇನು ಸೇರಿದೆ ನೋಡಬೇಕೇ?",
    gu: "પોલીસ ચકાસણી ફાઇલિંગ Pro પ્લાનનો ભાગ છે — બીજું શું સામેલ છે તે જોવું છે?",
    ml: "പോലീസ് പരിശോധന ഫയലിംഗ് Pro പ്ലാനിന്റെ ഭാഗമാണ് — മറ്റെന്തൊക്കെ ഉൾപ്പെടുന്നു എന്ന് കാണണോ?",
    pa: "ਪੁਲਿਸ ਤਸਦੀਕ ਫਾਈਲਿੰਗ Pro ਪਲਾਨ ਦਾ ਹਿੱਸਾ ਹੈ — ਹੋਰ ਕੀ ਸ਼ਾਮਲ ਹੈ ਵੇਖਣਾ ਹੈ?",
  },
  plan_gate_report: {
    en: "The AI move-in/out report is part of the Pro plan — want to see what else is included?",
    hi: "AI मूव-इन/आउट रिपोर्ट Pro प्लान का हिस्सा है — देखें और क्या शामिल है?",
    mr: "AI मूव्ह-इन/आउट अहवाल Pro प्लॅनचा भाग आहे — अजून काय समाविष्ट आहे ते पाहायचे?",
    bn: "AI মুভ-ইন/আউট রিপোর্ট Pro প্ল্যানের অংশ — আর কী অন্তর্ভুক্ত দেখবেন?",
    ta: "AI மூவ்-இன்/அவுட் அறிக்கை Pro திட்டத்தின் பகுதி — வேறு என்ன அடங்கும் என்று பார்க்கவா?",
    te: "AI మూవ్-ఇన్/అవుట్ నివేదిక Pro ప్లాన్‌లో భాగం — ఇంకా ఏమి ఉందో చూడాలా?",
    kn: "AI ಮೂವ್-ಇನ್/ಔಟ್ ವರದಿ Pro ಪ್ಲಾನ್‌ನ ಭಾಗ — ಇನ್ನೇನು ಸೇರಿದೆ ನೋಡಬೇಕೇ?",
    gu: "AI મૂવ-ઇન/આઉટ રિપોર્ટ Pro પ્લાનનો ભાગ છે — બીજું શું સામેલ છે તે જોવું છે?",
    ml: "AI മൂവ്-ഇൻ/ഔട്ട് റിപ്പോർട്ട് Pro പ്ലാനിന്റെ ഭാഗമാണ് — മറ്റെന്തൊക്കെ ഉൾപ്പെടുന്നു എന്ന് കാണണോ?",
    pa: "AI ਮੂਵ-ਇਨ/ਆਊਟ ਰਿਪੋਰਟ Pro ਪਲਾਨ ਦਾ ਹਿੱਸਾ ਹੈ — ਹੋਰ ਕੀ ਸ਼ਾਮਲ ਹੈ ਵੇਖਣਾ ਹੈ?",
  },
  plan_choose: {
    en: "Choose {name}", hi: "{name} चुनें", mr: "{name} निवडा", bn: "{name} বেছে নিন",
    ta: "{name} தேர்வுசெய்", te: "{name} ఎంచుకోండి", kn: "{name} ಆಯ್ಕೆಮಾಡಿ",
    gu: "{name} પસંદ કરો", ml: "{name} തിരഞ്ഞെടുക്കൂ", pa: "{name} ਚੁਣੋ",
  },
  plan_stay_free: {
    en: "Stay on Free", hi: "Free पर रहें", mr: "Free वरच राहा", bn: "Free-তেই থাকুন",
    ta: "Free-ல் இருங்கள்", te: "Free లోనే ఉండండి", kn: "Free ನಲ್ಲೇ ಇರಿ",
    gu: "Free પર જ રહો", ml: "Free-ൽ തുടരൂ", pa: "Free 'ਤੇ ਹੀ ਰਹੋ",
  },
  plan_current: {
    en: "Your current plan", hi: "आपका मौजूदा प्लान", mr: "तुमचा सध्याचा प्लॅन",
    bn: "আপনার বর্তমান প্ল্যান", ta: "உங்கள் தற்போதைய திட்டம்", te: "మీ ప్రస్తుత ప్లాన్",
    kn: "ನಿಮ್ಮ ಪ್ರಸ್ತುತ ಪ್ಲಾನ್", gu: "તમારો હાલનો પ્લાન",
    ml: "നിങ്ങളുടെ നിലവിലെ പ്ലാൻ", pa: "ਤੁਹਾਡਾ ਮੌਜੂਦਾ ਪਲਾਨ",
  },
  per_month: {
    en: "/month", hi: "/माह", mr: "/महिना", bn: "/মাস", ta: "/மாதம்", te: "/నెల",
    kn: "/ತಿಂಗಳು", gu: "/મહિનો", ml: "/മാസം", pa: "/ਮਹੀਨਾ",
  },
  // B. Payout convenience
  payout_instant_title: {
    en: "Get your rent today, not in 3 days", hi: "अपना किराया आज पाएं, 3 दिन में नहीं",
    mr: "तुमचे भाडे आजच मिळवा, 3 दिवसांत नाही", bn: "আপনার ভাড়া আজই পান, ৩ দিনে নয়",
    ta: "உங்கள் வாடகையை இன்றே பெறுங்கள், 3 நாட்களில் அல்ல", te: "మీ అద్దెను ఈ రోజే పొందండి, 3 రోజుల్లో కాదు",
    kn: "ನಿಮ್ಮ ಬಾಡಿಗೆಯನ್ನು ಇಂದೇ ಪಡೆಯಿರಿ, 3 ದಿನಗಳಲ್ಲಿ ಅಲ್ಲ", gu: "તમારું ભાડું આજે જ મેળવો, 3 દિવસમાં નહીં",
    ml: "നിങ്ങളുടെ വാടക ഇന്നുതന്നെ നേടൂ, 3 ദിവസത്തിനുള്ളിലല്ല", pa: "ਆਪਣਾ ਕਿਰਾਇਆ ਅੱਜ ਹੀ ਲਓ, 3 ਦਿਨਾਂ ਵਿੱਚ ਨਹੀਂ",
  },
  payout_standard: {
    en: "Standard transfer (free, 2–3 days)", hi: "सामान्य ट्रांसफर (मुफ़्त, 2–3 दिन)",
    mr: "सामान्य ट्रान्सफर (मोफत, 2–3 दिवस)", bn: "সাধারণ ট্রান্সফার (ফ্রি, ২–৩ দিন)",
    ta: "வழக்கமான பரிமாற்றம் (இலவசம், 2–3 நாட்கள்)", te: "సాధారణ బదిలీ (ఉచితం, 2–3 రోజులు)",
    kn: "ಸಾಮಾನ್ಯ ವರ್ಗಾವಣೆ (ಉಚಿತ, 2–3 ದಿನ)", gu: "સામાન્ય ટ્રાન્સફર (મફત, 2–3 દિવસ)",
    ml: "സാധാരണ ട്രാൻസ്ഫർ (സൗജന്യം, 2–3 ദിവസം)", pa: "ਸਧਾਰਨ ਟ੍ਰਾਂਸਫਰ (ਮੁਫ਼ਤ, 2–3 ਦਿਨ)",
  },
  payout_choose_hint: {
    en: "Choose how you'd like to receive your rent", hi: "चुनें कि आप किराया कैसे पाना चाहते हैं",
    mr: "तुम्हाला भाडे कसे मिळवायचे ते निवडा", bn: "আপনি কীভাবে ভাড়া পেতে চান বেছে নিন",
    ta: "நீங்கள் வாடகையை எப்படி பெற விரும்புகிறீர்கள் என்பதை தேர்வுசெய்யவும்", te: "మీరు అద్దెను ఎలా పొందాలనుకుంటున్నారో ఎంచుకోండి",
    kn: "ನೀವು ಬಾಡಿಗೆಯನ್ನು ಹೇಗೆ ಪಡೆಯಬಯಸುತ್ತೀರಿ ಎಂದು ಆಯ್ಕೆಮಾಡಿ", gu: "તમે ભાડું કેવી રીતે મેળવવા માંગો છો તે પસંદ કરો",
    ml: "നിങ്ങൾ വാടക എങ്ങനെ ലഭിക്കണം എന്ന് തിരഞ്ഞെടുക്കൂ", pa: "ਚੁਣੋ ਕਿ ਤੁਸੀਂ ਕਿਰਾਇਆ ਕਿਵੇਂ ਲੈਣਾ ਚਾਹੁੰਦੇ ਹੋ",
  },
  // C. Service bundles
  svc_handle: {
    en: "Let us handle this", hi: "यह हम संभाल लेते हैं", mr: "हे आम्ही सांभाळतो",
    bn: "এটি আমরা সামলে নিই", ta: "இதை நாங்கள் கவனித்துக்கொள்கிறோம்", te: "దీన్ని మేము చూసుకుంటాం",
    kn: "ಇದನ್ನು ನಾವು ನೋಡಿಕೊಳ್ಳುತ್ತೇವೆ", gu: "આ અમે સંભાળી લઈએ છીએ",
    ml: "ഇത് ഞങ്ങൾ കൈകാര്യം ചെയ്യാം", pa: "ਇਹ ਅਸੀਂ ਸੰਭਾਲ ਲੈਂਦੇ ਹਾਂ",
  },
  svc_diy: {
    en: "Do it yourself instead", hi: "इसके बजाय खुद करें", mr: "त्याऐवजी स्वतः करा",
    bn: "বরং নিজে করুন", ta: "அதற்குப் பதிலாக நீங்களே செய்யுங்கள்", te: "బదులుగా మీరే చేయండి",
    kn: "ಬದಲಿಗೆ ನೀವೇ ಮಾಡಿ", gu: "તેના બદલે જાતે કરો",
    ml: "പകരം സ്വയം ചെയ്യൂ", pa: "ਇਸ ਦੀ ਥਾਂ ਖੁਦ ਕਰੋ",
  },
  svc_anchor: {
    en: "Most {who} charge ₹{low}–{high} for this.", hi: "अधिकतर {who} इसके लिए ₹{low}–{high} लेते हैं।",
    mr: "बहुतेक {who} यासाठी ₹{low}–{high} घेतात.", bn: "বেশিরভাগ {who} এর জন্য ₹{low}–{high} নেয়।",
    ta: "பெரும்பாலான {who} இதற்கு ₹{low}–{high} வாங்குகிறார்கள்.", te: "చాలామంది {who} దీనికి ₹{low}–{high} తీసుకుంటారు.",
    kn: "ಹೆಚ್ಚಿನ {who} ಇದಕ್ಕೆ ₹{low}–{high} ತೆಗೆದುಕೊಳ್ಳುತ್ತಾರೆ.", gu: "મોટાભાગના {who} આ માટે ₹{low}–{high} લે છે.",
    ml: "മിക്ക {who} ഇതിന് ₹{low}–{high} ഈടാക്കുന്നു.", pa: "ਜ਼ਿਆਦਾਤਰ {who} ਇਸ ਲਈ ₹{low}–{high} ਲੈਂਦੇ ਹਨ।",
  },
  svc_agreement_title: {
    en: "Ready-to-sign rent agreement, e-stamp & e-sign", hi: "साइन के लिए तैयार किराया एग्रीमेंट, e-स्टाम्प व e-साइन",
    mr: "सही करण्यास तयार भाडे करार, e-स्टॅम्प व e-सही", bn: "সাইনের জন্য তৈরি ভাড়া চুক্তি, e-স্ট্যাম্প ও e-সাইন",
    ta: "கையொப்பமிட தயாராக வாடகை ஒப்பந்தம், e-ஸ்டாம்ப் & e-கையொப்பம்", te: "సంతకానికి సిద్ధమైన అద్దె ఒప్పందం, e-స్టాంప్ & e-సంతకం",
    kn: "ಸಹಿಗೆ ಸಿದ್ಧವಾದ ಬಾಡಿಗೆ ಒಪ್ಪಂದ, e-ಸ್ಟ್ಯಾಂಪ್ & e-ಸಹಿ", gu: "સહી માટે તૈયાર ભાડા કરાર, e-સ્ટેમ્પ અને e-સહી",
    ml: "ഒപ്പിടാൻ തയ്യാറായ വാടക കരാർ, e-സ്റ്റാമ്പ് & e-ഒപ്പ്", pa: "ਦਸਤਖਤ ਲਈ ਤਿਆਰ ਕਿਰਾਇਆ ਇਕਰਾਰਨਾਮਾ, e-ਸਟੈਂਪ ਤੇ e-ਦਸਤਖਤ",
  },
  // D. Featured
  featured_cta: {
    en: "Boost my listing", hi: "मेरी लिस्टिंग बूस्ट करें", mr: "माझी लिस्टिंग बूस्ट करा",
    bn: "আমার লিস্টিং বুস্ট করুন", ta: "என் பட்டியலை பூஸ்ட் செய்", te: "నా లిస్టింగ్‌ను బూస్ట్ చేయండి",
    kn: "ನನ್ನ ಲಿಸ್ಟಿಂಗ್ ಬೂಸ್ಟ್ ಮಾಡಿ", gu: "મારી લિસ્ટિંગ બૂસ્ટ કરો",
    ml: "എന്റെ ലിസ്റ്റിംഗ് ബൂസ്റ്റ് ചെയ്യൂ", pa: "ਮੇਰੀ ਲਿਸਟਿੰਗ ਬੂਸਟ ਕਰੋ",
  },
  featured_line: {
    en: "Your home has had {views} views in {days} days — boosted listings get matched 2–3x faster.",
    hi: "आपके घर को {days} दिनों में {views} बार देखा गया — बूस्ट की गई लिस्टिंग 2–3 गुना तेज़ी से मैच होती हैं।",
    mr: "तुमचे घर {days} दिवसांत {views} वेळा पाहिले गेले — बूस्ट केलेल्या लिस्टिंग 2–3 पट वेगाने मॅच होतात.",
    bn: "আপনার বাড়ি {days} দিনে {views} বার দেখা হয়েছে — বুস্ট করা লিস্টিং ২–৩ গুণ দ্রুত ম্যাচ হয়।",
    ta: "உங்கள் வீடு {days} நாட்களில் {views} முறை பார்க்கப்பட்டது — பூஸ்ட் செய்யப்பட்ட பட்டியல்கள் 2–3 மடங்கு வேகமாக பொருந்தும்.",
    te: "మీ ఇంటిని {days} రోజుల్లో {views} సార్లు చూశారు — బూస్ట్ చేసిన లిస్టింగ్‌లు 2–3 రెట్లు వేగంగా మ్యాచ్ అవుతాయి.",
    kn: "ನಿಮ್ಮ ಮನೆಯನ್ನು {days} ದಿನಗಳಲ್ಲಿ {views} ಬಾರಿ ನೋಡಲಾಗಿದೆ — ಬೂಸ್ಟ್ ಮಾಡಿದ ಲಿಸ್ಟಿಂಗ್‌ಗಳು 2–3 ಪಟ್ಟು ವೇಗವಾಗಿ ಮ್ಯಾಚ್ ಆಗುತ್ತವೆ.",
    gu: "તમારું ઘર {days} દિવસમાં {views} વાર જોવાયું — બૂસ્ટ કરેલી લિસ્ટિંગ 2–3 ગણી ઝડપથી મેચ થાય છે.",
    ml: "നിങ്ങളുടെ വീട് {days} ദിവസത്തിൽ {views} തവണ കണ്ടു — ബൂസ്റ്റ് ചെയ്ത ലിസ്റ്റിംഗുകൾ 2–3 മടങ്ങ് വേഗത്തിൽ മാച്ച് ആകുന്നു.",
    pa: "ਤੁਹਾਡਾ ਘਰ {days} ਦਿਨਾਂ ਵਿੱਚ {views} ਵਾਰ ਵੇਖਿਆ ਗਿਆ — ਬੂਸਟ ਕੀਤੀਆਂ ਲਿਸਟਿੰਗਾਂ 2–3 ਗੁਣਾ ਤੇਜ਼ੀ ਨਾਲ ਮੈਚ ਹੁੰਦੀਆਂ ਹਨ।",
  },
  // E. Matching
  match_disclosure: {
    en: "No charge unless you find a tenant through My Manger.",
    hi: "जब तक My Manger से किराएदार न मिले, कोई राशि नहीं।",
    mr: "My Manger मधून भाडेकरू मिळेपर्यंत कोणतेही शुल्क नाही.",
    bn: "My Manger থেকে ভাড়াটে না পাওয়া পর্যন্ত কোনো চার্জ নেই।",
    ta: "My Manger மூலம் வாடகைதாரர் கிடைக்கும் வரை எந்தக் கட்டணமும் இல்லை.",
    te: "My Manger ద్వారా అద్దెదారు దొరికే వరకు ఎలాంటి ఛార్జ్ లేదు.",
    kn: "My Manger ಮೂಲಕ ಬಾಡಿಗೆದಾರ ಸಿಗುವವರೆಗೆ ಯಾವುದೇ ಶುಲ್ಕವಿಲ್ಲ.",
    gu: "My Manger દ્વારા ભાડૂત ન મળે ત્યાં સુધી કોઈ ચાર્જ નથી.",
    ml: "My Manger വഴി വാടകക്കാരനെ കണ്ടെത്തുന്നതുവരെ ചാർജൊന്നുമില്ല.",
    pa: "My Manger ਰਾਹੀਂ ਕਿਰਾਏਦਾਰ ਮਿਲਣ ਤੱਕ ਕੋਈ ਚਾਰਜ ਨਹੀਂ।",
  },
  match_confirmed_title: {
    en: "Your new tenancy is confirmed", hi: "आपकी नई टेनेंसी पक्की हो गई",
    mr: "तुमची नवी टेनन्सी निश्चित झाली", bn: "আপনার নতুন টেন্যান্সি নিশ্চিত হয়েছে",
    ta: "உங்கள் புதிய குத்தகை உறுதிசெய்யப்பட்டது", te: "మీ కొత్త అద్దె ఖాయమైంది",
    kn: "ನಿಮ್ಮ ಹೊಸ ಬಾಡಿಗೆ ಖಚಿತವಾಗಿದೆ", gu: "તમારી નવી ટેનન્સી નક્કી થઈ ગઈ",
    ml: "നിങ്ങളുടെ പുതിയ ടെനൻസി ഉറപ്പായി", pa: "ਤੁਹਾਡੀ ਨਵੀਂ ਟੈਨੈਂਸੀ ਪੱਕੀ ਹੋ ਗਈ",
  },
  match_line: {
    en: "Here's your one-time ₹{amount} match reward for a successful tenant.",
    hi: "सफल किराएदार के लिए यह एक-बार का ₹{amount} मैच रिवॉर्ड है।",
    mr: "यशस्वी भाडेकरूसाठी हे एक-वेळचे ₹{amount} मॅच रिवॉर्ड आहे.",
    bn: "সফল ভাড়াটের জন্য এই এককালীন ₹{amount} ম্যাচ রিওয়ার্ড।",
    ta: "வெற்றிகரமான வாடகைதாரருக்கான ஒரு-முறை ₹{amount} மேட்ச் வெகுமதி இதோ.",
    te: "విజయవంతమైన అద్దెదారుకు ఇది ఒక-సారి ₹{amount} మ్యాచ్ రివార్డ్.",
    kn: "ಯಶಸ್ವಿ ಬಾಡಿಗೆದಾರನಿಗಾಗಿ ಇದು ಒಂದು-ಬಾರಿ ₹{amount} ಮ್ಯಾಚ್ ರಿವಾರ್ಡ್.",
    gu: "સફળ ભાડૂત માટે આ એક-વખતનું ₹{amount} મેચ રિવોર્ડ છે.",
    ml: "വിജയകരമായ വാടകക്കാരന് ഇതാ ഒറ്റത്തവണ ₹{amount} മാച്ച് റിവാർഡ്.",
    pa: "ਸਫਲ ਕਿਰਾਏਦਾਰ ਲਈ ਇਹ ਇੱਕ-ਵਾਰ ਦਾ ₹{amount} ਮੈਚ ਇਨਾਮ ਹੈ।",
  },
  match_anchor: {
    en: "A broker usually takes one month's rent (~₹{rent}).", hi: "ब्रोकर आमतौर पर एक महीने का किराया लेता है (~₹{rent})।",
    mr: "ब्रोकर सहसा एका महिन्याचे भाडे घेतो (~₹{rent}).", bn: "ব্রোকার সাধারণত এক মাসের ভাড়া নেয় (~₹{rent})।",
    ta: "தரகர் பொதுவாக ஒரு மாத வாடகையை வாங்குவார் (~₹{rent}).", te: "బ్రోకర్ సాధారణంగా ఒక నెల అద్దె తీసుకుంటాడు (~₹{rent}).",
    kn: "ಬ್ರೋಕರ್ ಸಾಮಾನ್ಯವಾಗಿ ಒಂದು ತಿಂಗಳ ಬಾಡಿಗೆ ತೆಗೆದುಕೊಳ್ಳುತ್ತಾನೆ (~₹{rent}).", gu: "બ્રોકર સામાન્ય રીતે એક મહિનાનું ભાડું લે છે (~₹{rent}).",
    ml: "ബ്രോക്കർ സാധാരണയായി ഒരു മാസത്തെ വാടക എടുക്കും (~₹{rent}).", pa: "ਬ੍ਰੋਕਰ ਆਮ ਤੌਰ 'ਤੇ ਇੱਕ ਮਹੀਨੇ ਦਾ ਕਿਰਾਇਆ ਲੈਂਦਾ ਹੈ (~₹{rent})।",
  },
  match_pay: {
    en: "Confirm & pay ₹{amount}", hi: "पुष्टि करें व ₹{amount} दें", mr: "पुष्टी करा व ₹{amount} भरा",
    bn: "নিশ্চিত করুন ও ₹{amount} দিন", ta: "உறுதிசெய்து ₹{amount} செலுத்து", te: "నిర్ధారించి ₹{amount} చెల్లించండి",
    kn: "ಖಚಿತಪಡಿಸಿ ₹{amount} ಪಾವತಿಸಿ", gu: "પુષ્ટિ કરો અને ₹{amount} ચૂકવો",
    ml: "ഉറപ്പിച്ച് ₹{amount} അടയ്ക്കൂ", pa: "ਪੁਸ਼ਟੀ ਕਰੋ ਤੇ ₹{amount} ਭਰੋ",
  },
  // F. AI cap
  ai_cap_title: {
    en: "Your assistant is ready for more", hi: "आपका सहायक और मदद के लिए तैयार है",
    mr: "तुमचा सहाय्यक अधिक मदतीसाठी तयार आहे", bn: "আপনার সহকারী আরও সাহায্যের জন্য প্রস্তুত",
    ta: "உங்கள் உதவியாளர் மேலும் உதவ தயாராக உள்ளார்", te: "మీ సహాయకుడు మరింత సహాయానికి సిద్ధంగా ఉన్నాడు",
    kn: "ನಿಮ್ಮ ಸಹಾಯಕ ಇನ್ನಷ್ಟು ಸಹಾಯಕ್ಕೆ ಸಿದ್ಧ", gu: "તમારો સહાયક વધુ મદદ માટે તૈયાર છે",
    ml: "നിങ്ങളുടെ അസിസ്റ്റന്റ് കൂടുതൽ സഹായത്തിന് തയ്യാർ", pa: "ਤੁਹਾਡਾ ਸਹਾਇਕ ਹੋਰ ਮਦਦ ਲਈ ਤਿਆਰ ਹੈ",
  },
  ai_cap_line: {
    en: "Upgrade to keep getting unlimited help in your language.", hi: "अपनी भाषा में असीमित मदद पाने के लिए अपग्रेड करें।",
    mr: "तुमच्या भाषेत असीमित मदत मिळवत राहण्यासाठी अपग्रेड करा.", bn: "আপনার ভাষায় সীমাহীন সাহায্য পেতে আপগ্রেড করুন।",
    ta: "உங்கள் மொழியில் வரம்பற்ற உதவியைத் தொடர அப்கிரேட் செய்யுங்கள்.", te: "మీ భాషలో అపరిమిత సహాయం పొందడానికి అప్‌గ్రేడ్ చేయండి.",
    kn: "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಅಪರಿಮಿತ ಸಹಾಯ ಪಡೆಯಲು ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.", gu: "તમારી ભાષામાં અમર્યાદિત મદદ મેળવવા અપગ્રેડ કરો.",
    ml: "നിങ്ങളുടെ ഭാഷയിൽ പരിധിയില്ലാത്ത സഹായം തുടരാൻ അപ്‌ഗ്രേഡ് ചെയ്യൂ.", pa: "ਆਪਣੀ ਭਾਸ਼ਾ ਵਿੱਚ ਅਸੀਮਤ ਮਦਦ ਲੈਂਦੇ ਰਹਿਣ ਲਈ ਅਪਗ੍ਰੇਡ ਕਰੋ।",
  },
  ai_cap_cta: {
    en: "Upgrade for unlimited help", hi: "असीमित मदद के लिए अपग्रेड करें",
    mr: "असीमित मदतीसाठी अपग्रेड करा", bn: "সীমাহীন সাহায্যের জন্য আপগ্রেড করুন",
    ta: "வரம்பற்ற உதவிக்கு அப்கிரேட் செய்", te: "అపరిమిత సహాయానికి అప్‌గ్రేడ్ చేయండి",
    kn: "ಅಪರಿಮಿತ ಸಹಾಯಕ್ಕೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ", gu: "અમર્યાદિત મદદ માટે અપગ્રેડ કરો",
    ml: "പരിധിയില്ലാത്ത സഹായത്തിന് അപ്‌ഗ്രേഡ് ചെയ്യൂ", pa: "ਅਸੀਮਤ ਮਦਦ ਲਈ ਅਪਗ੍ਰੇਡ ਕਰੋ",
  },
  // G. Insurance
  ins_deposit_title: {
    en: "Protect your deposit", hi: "अपनी जमा राशि सुरक्षित करें", mr: "तुमची डिपॉझिट सुरक्षित करा",
    bn: "আপনার জমা সুরক্ষিত করুন", ta: "உங்கள் வைப்புத்தொகையை பாதுகாக்கவும்", te: "మీ డిపాజిట్‌ను రక్షించండి",
    kn: "ನಿಮ್ಮ ಠೇವಣಿಯನ್ನು ರಕ್ಷಿಸಿ", gu: "તમારી ડિપોઝિટ સુરક્ષિત કરો",
    ml: "നിങ്ങളുടെ ഡിപ്പോസിറ്റ് സംരക്ഷിക്കൂ", pa: "ਆਪਣੀ ਜਮ੍ਹਾਂ ਰਾਸ਼ੀ ਸੁਰੱਖਿਅਤ ਕਰੋ",
  },
  ins_income_title: {
    en: "Protect your rental income", hi: "अपनी किराया आय सुरक्षित करें", mr: "तुमचे भाडे उत्पन्न सुरक्षित करा",
    bn: "আপনার ভাড়ার আয় সুরক্ষিত করুন", ta: "உங்கள் வாடகை வருமானத்தை பாதுகாக்கவும்", te: "మీ అద్దె ఆదాయాన్ని రక్షించండి",
    kn: "ನಿಮ್ಮ ಬಾಡಿಗೆ ಆದಾಯವನ್ನು ರಕ್ಷಿಸಿ", gu: "તમારી ભાડાની આવક સુરક્ષિત કરો",
    ml: "നിങ്ങളുടെ വാടക വരുമാനം സംരക്ഷിക്കൂ", pa: "ਆਪਣੀ ਕਿਰਾਇਆ ਆਮਦਨ ਸੁਰੱਖਿਅਤ ਕਰੋ",
  },
  ins_deposit_scenario: {
    en: "If there's a dispute, your deposit is covered up to ₹{cover}.",
    hi: "विवाद होने पर, आपकी जमा राशि ₹{cover} तक सुरक्षित है।",
    mr: "वाद झाल्यास, तुमची डिपॉझिट ₹{cover} पर्यंत संरक्षित आहे.",
    bn: "বিরোধ হলে, আপনার জমা ₹{cover} পর্যন্ত সুরক্ষিত।",
    ta: "தகராறு ஏற்பட்டால், உங்கள் வைப்புத்தொகை ₹{cover} வரை பாதுகாக்கப்படும்.",
    te: "వివాదం వస్తే, మీ డిపాజిట్ ₹{cover} వరకు కవర్ అవుతుంది.",
    kn: "ವಿವಾದ ಬಂದರೆ, ನಿಮ್ಮ ಠೇವಣಿ ₹{cover} ವರೆಗೆ ರಕ್ಷಿತ.",
    gu: "વિવાદ થાય તો, તમારી ડિપોઝિટ ₹{cover} સુધી કવર થાય છે.",
    ml: "തർക്കമുണ്ടായാൽ, നിങ്ങളുടെ ഡിപ്പോസിറ്റ് ₹{cover} വരെ പരിരക്ഷിതം.",
    pa: "ਵਿਵਾਦ ਹੋਣ 'ਤੇ, ਤੁਹਾਡੀ ਜਮ੍ਹਾਂ ਰਾਸ਼ੀ ₹{cover} ਤੱਕ ਕਵਰ ਹੈ।",
  },
  ins_income_scenario: {
    en: "If your tenant defaults, your income is covered up to ₹{cover}.",
    hi: "किराएदार भुगतान न करे, तो आपकी आय ₹{cover} तक सुरक्षित है।",
    mr: "भाडेकरूने भरले नाही, तर तुमचे उत्पन्न ₹{cover} पर्यंत संरक्षित आहे.",
    bn: "ভাড়াটে না দিলে, আপনার আয় ₹{cover} পর্যন্ত সুরক্ষিত।",
    ta: "வாடகைதாரர் செலுத்தாவிட்டால், உங்கள் வருமானம் ₹{cover} வரை பாதுகாக்கப்படும்.",
    te: "అద్దెదారు చెల్లించకపోతే, మీ ఆదాయం ₹{cover} వరకు కవర్ అవుతుంది.",
    kn: "ಬಾಡಿಗೆದಾರ ಪಾವತಿಸದಿದ್ದರೆ, ನಿಮ್ಮ ಆದಾಯ ₹{cover} ವರೆಗೆ ರಕ್ಷಿತ.",
    gu: "ભાડૂત ન ચૂકવે તો, તમારી આવક ₹{cover} સુધી કવર થાય છે.",
    ml: "വാടകക്കാരൻ അടച്ചില്ലെങ്കിൽ, നിങ്ങളുടെ വരുമാനം ₹{cover} വരെ പരിരക്ഷിതം.",
    pa: "ਕਿਰਾਏਦਾਰ ਨਾ ਭਰੇ, ਤਾਂ ਤੁਹਾਡੀ ਆਮਦਨ ₹{cover} ਤੱਕ ਕਵਰ ਹੈ।",
  },
  ins_cta: {
    en: "Add protection", hi: "सुरक्षा जोड़ें", mr: "संरक्षण जोडा", bn: "সুরক্ষা যোগ করুন",
    ta: "பாதுகாப்பைச் சேர்", te: "రక్షణను జోడించండి", kn: "ರಕ್ಷಣೆ ಸೇರಿಸಿ",
    gu: "સુરક્ષા ઉમેરો", ml: "സംരക്ഷണം ചേർക്കൂ", pa: "ਸੁਰੱਖਿਆ ਜੋੜੋ",
  },
  // H. Tax pack
  tax_title: {
    en: "Download my Tax Pack", hi: "मेरा Tax Pack डाउनलोड करें", mr: "माझा Tax Pack डाउनलोड करा",
    bn: "আমার Tax Pack ডাউনলোড করুন", ta: "என் Tax Pack-ஐ பதிவிறக்கு", te: "నా Tax Pack డౌన్‌లోడ్ చేయండి",
    kn: "ನನ್ನ Tax Pack ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ", gu: "મારો Tax Pack ડાઉનલોડ કરો",
    ml: "എന്റെ Tax Pack ഡൗൺലോഡ് ചെയ്യൂ", pa: "ਮੇਰਾ Tax Pack ਡਾਊਨਲੋਡ ਕਰੋ",
  },
  tax_line: {
    en: "CA-ready, formatted for ITR filing.", hi: "CA-तैयार, ITR फाइलिंग के लिए फ़ॉर्मेट किया हुआ।",
    mr: "CA-तयार, ITR फाइलिंगसाठी फॉरमॅट केलेला.", bn: "CA-প্রস্তুত, ITR ফাইলিংয়ের জন্য ফরম্যাট করা।",
    ta: "CA-தயார், ITR தாக்கலுக்கு வடிவமைக்கப்பட்டது.", te: "CA-సిద్ధం, ITR ఫైలింగ్ కోసం ఫార్మాట్ చేయబడింది.",
    kn: "CA-ಸಿದ್ಧ, ITR ಫೈಲಿಂಗ್‌ಗೆ ಫಾರ್ಮ್ಯಾಟ್ ಮಾಡಲಾಗಿದೆ.", gu: "CA-તૈયાર, ITR ફાઇલિંગ માટે ફોર્મેટ કરેલ.",
    ml: "CA-തയ്യാർ, ITR ഫയലിംഗിനായി ഫോർമാറ്റ് ചെയ്തത്.", pa: "CA-ਤਿਆਰ, ITR ਫਾਈਲਿੰਗ ਲਈ ਫਾਰਮੈਟ ਕੀਤਾ।",
  },
  // common
  not_now: {
    en: "Not now", hi: "अभी नहीं", mr: "आत्ता नको", bn: "এখন নয়", ta: "இப்போது வேண்டாம்",
    te: "ఇప్పుడు వద్దు", kn: "ಈಗ ಬೇಡ", gu: "હમણાં નહીં", ml: "ഇപ്പോൾ വേണ്ട", pa: "ਹੁਣੇ ਨਹੀਂ",
  },
  vs: {
    en: "vs", hi: "बनाम", mr: "विरुद्ध", bn: "বনাম", ta: "எதிராக", te: "వర్సెస్",
    kn: "ವಿರುದ್ಧ", gu: "વિરુદ્ધ", ml: "vs", pa: "ਬਨਾਮ",
  },
  free_word: {
    en: "Free", hi: "मुफ़्त", mr: "मोफत", bn: "ফ্রি", ta: "இலவசம்", te: "ఉచితం",
    kn: "ಉಚಿತ", gu: "મફત", ml: "സൗജന്യം", pa: "ਮੁਫ਼ਤ",
  },
  // I. Revenue snapshot (owner value card)
  value_title: {
    en: "The value you're getting", hi: "आपको मिल रहा फ़ायदा", mr: "तुम्हाला मिळणारे मूल्य",
    bn: "আপনি যে সুবিধা পাচ্ছেন", ta: "நீங்கள் பெறும் மதிப்பு", te: "మీకు లభిస్తున్న విలువ",
    kn: "ನಿಮಗೆ ಸಿಗುತ್ತಿರುವ ಮೌಲ್ಯ", gu: "તમને મળી રહેલો ફાયદો",
    ml: "നിങ്ങൾക്ക് ലഭിക്കുന്ന മൂല്യം", pa: "ਤੁਹਾਨੂੰ ਮਿਲ ਰਿਹਾ ਫ਼ਾਇਦਾ",
  },
  value_plan: {
    en: "Your plan", hi: "आपका प्लान", mr: "तुमचा प्लॅन", bn: "আপনার প্ল্যান",
    ta: "உங்கள் திட்டம்", te: "మీ ప్లాన్", kn: "ನಿಮ್ಮ ಪ್ಲಾನ್",
    gu: "તમારો પ્લાન", ml: "നിങ്ങളുടെ പ്ലാൻ", pa: "ਤੁਹਾਡਾ ਪਲਾਨ",
  },
  value_boosts: {
    en: "Listings boosted", hi: "बूस्ट की गई लिस्टिंग", mr: "बूस्ट केलेल्या लिस्टिंग",
    bn: "বুস্ট করা লিস্টিং", ta: "பூஸ்ட் செய்த பட்டியல்கள்", te: "బూస్ట్ చేసిన లిస్టింగ్‌లు",
    kn: "ಬೂಸ್ಟ್ ಮಾಡಿದ ಲಿಸ್ಟಿಂಗ್‌ಗಳು", gu: "બૂસ્ટ કરેલી લિસ્ટિંગ",
    ml: "ബൂസ്റ്റ് ചെയ്ത ലിസ്റ്റിംഗുകൾ", pa: "ਬੂਸਟ ਕੀਤੀਆਂ ਲਿਸਟਿੰਗਾਂ",
  },
  value_instant: {
    en: "Instant payouts", hi: "तुरंत भुगतान", mr: "त्वरित पेआउट", bn: "তাৎক্ষণিক পেআউট",
    ta: "உடனடி பேஅவுட்கள்", te: "తక్షణ చెల్లింపులు", kn: "ತಕ್ಷಣದ ಪಾವತಿಗಳು",
    gu: "તાત્કાલિક પેઆઉટ", ml: "തൽക്ഷണ പേഔട്ടുകൾ", pa: "ਤੁਰੰਤ ਭੁਗਤਾਨ",
  },
  value_services: {
    en: "Services used", hi: "इस्तेमाल की गई सेवाएं", mr: "वापरलेल्या सेवा",
    bn: "ব্যবহৃত পরিষেবা", ta: "பயன்படுத்திய சேவைகள்", te: "వాడిన సేవలు",
    kn: "ಬಳಸಿದ ಸೇವೆಗಳು", gu: "વાપરેલી સેવાઓ",
    ml: "ഉപയോഗിച്ച സേവനങ്ങൾ", pa: "ਵਰਤੀਆਂ ਸੇਵਾਵਾਂ",
  },
  value_invested: {
    en: "₹{amount} invested in growing your rentals", hi: "आपकी रेंटल बढ़ाने में ₹{amount} लगाए गए",
    mr: "तुमची भाड्याची मालमत्ता वाढवण्यासाठी ₹{amount} गुंतवले", bn: "আপনার ভাড়া বাড়াতে ₹{amount} বিনিয়োগ করা হয়েছে",
    ta: "உங்கள் வாடகைகளை வளர்க்க ₹{amount} முதலீடு செய்யப்பட்டது", te: "మీ అద్దెలను పెంచడానికి ₹{amount} పెట్టుబడి పెట్టారు",
    kn: "ನಿಮ್ಮ ಬಾಡಿಗೆಗಳನ್ನು ಬೆಳೆಸಲು ₹{amount} ಹೂಡಿಕೆ ಮಾಡಲಾಗಿದೆ", gu: "તમારા ભાડાં વધારવા માટે ₹{amount} રોકાણ કરાયું",
    ml: "നിങ്ങളുടെ വാടകകൾ വളർത്താൻ ₹{amount} നിക്ഷേപിച്ചു", pa: "ਤੁਹਾਡੇ ਕਿਰਾਏ ਵਧਾਉਣ ਲਈ ₹{amount} ਲਗਾਏ ਗਏ",
  },
  value_nudge_free: {
    en: "Unlock priority matching & more", hi: "प्राथमिकता मैचिंग और बहुत कुछ अनलॉक करें",
    mr: "प्राधान्य मॅचिंग व बरेच काही अनलॉक करा", bn: "অগ্রাধিকার ম্যাচিং ও আরও আনলক করুন",
    ta: "முன்னுரிமை பொருத்தம் & மேலும் திறக்கவும்", te: "ప్రాధాన్య మ్యాచింగ్ & మరిన్ని అన్‌లాక్ చేయండి",
    kn: "ಆದ್ಯತಾ ಮ್ಯಾಚಿಂಗ್ ಮತ್ತು ಇನ್ನಷ್ಟು ಅನ್‌ಲಾಕ್ ಮಾಡಿ", gu: "પ્રાયોરિટી મેચિંગ અને વધુ અનલૉક કરો",
    ml: "മുൻഗണനാ മാച്ചിംഗ് & കൂടുതൽ അൺലോക്ക് ചെയ്യൂ", pa: "ਤਰਜੀਹੀ ਮੈਚਿੰਗ ਤੇ ਹੋਰ ਅਨਲਾਕ ਕਰੋ",
  },
  // J. Boost insights / payout ledger / renewal
  payout_ledger_title: {
    en: "Instant payouts you've used", hi: "आपके इस्तेमाल किए तुरंत भुगतान",
    mr: "तुम्ही वापरलेले त्वरित पेआउट", bn: "আপনি ব্যবহার করা তাৎক্ষণিক পেআউট",
    ta: "நீங்கள் பயன்படுத்திய உடனடி பேஅவுட்கள்", te: "మీరు వాడిన తక్షణ చెల్లింపులు",
    kn: "ನೀವು ಬಳಸಿದ ತಕ್ಷಣದ ಪಾವತಿಗಳು", gu: "તમે વાપરેલા તાત્કાલિક પેઆઉટ",
    ml: "നിങ്ങൾ ഉപയോഗിച്ച തൽക്ഷണ പേഔട്ടുകൾ", pa: "ਤੁਹਾਡੇ ਵਰਤੇ ਤੁਰੰਤ ਭੁਗਤਾਨ",
  },
  payout_time_saved: {
    en: "~3 days sooner", hi: "~3 दिन पहले", mr: "~3 दिवस आधी", bn: "~৩ দিন আগে",
    ta: "~3 நாட்கள் முன்னதாக", te: "~3 రోజులు ముందుగా", kn: "~3 ದಿನ ಮೊದಲೇ",
    gu: "~3 દિવસ વહેલા", ml: "~3 ദിവസം നേരത്തെ", pa: "~3 ਦਿਨ ਪਹਿਲਾਂ",
  },
  boost_insights_title: {
    en: "What your boosts earned", hi: "आपके बूस्ट ने क्या कमाया", mr: "तुमच्या बूस्टने काय मिळवले",
    bn: "আপনার বুস্ট যা এনেছে", ta: "உங்கள் பூஸ்ட் ஈட்டியது", te: "మీ బూస్ట్ సాధించింది",
    kn: "ನಿಮ್ಮ ಬೂಸ್ಟ್ ಗಳಿಸಿದ್ದು", gu: "તમારા બૂસ્ટે શું કમાવ્યું",
    ml: "നിങ്ങളുടെ ബൂസ്റ്റ് നേടിയത്", pa: "ਤੁਹਾਡੇ ਬੂਸਟ ਨੇ ਕੀ ਕਮਾਇਆ",
  },
  boost_extra_views: {
    en: "+{n} views", hi: "+{n} व्यूज़", mr: "+{n} व्ह्यूज", bn: "+{n} ভিউ",
    ta: "+{n} பார்வைகள்", te: "+{n} వీక్షణలు", kn: "+{n} ವೀಕ್ಷಣೆಗಳು",
    gu: "+{n} વ્યૂ", ml: "+{n} കാഴ്ചകൾ", pa: "+{n} ਵਿਊਜ਼",
  },
  boost_extra_enquiries: {
    en: "+{n} enquiries", hi: "+{n} पूछताछ", mr: "+{n} चौकशी", bn: "+{n} অনুসন্ধান",
    ta: "+{n} விசாரணைகள்", te: "+{n} విచారణలు", kn: "+{n} ವಿಚಾರಣೆಗಳು",
    gu: "+{n} પૂછપરછ", ml: "+{n} അന്വേഷണങ്ങൾ", pa: "+{n} ਪੁੱਛਗਿੱਛ",
  },
  renewal_title: {
    en: "Agreements ending soon", hi: "जल्द खत्म हो रहे एग्रीमेंट", mr: "लवकर संपणारे करार",
    bn: "শীঘ্রই শেষ হওয়া চুক্তি", ta: "விரைவில் முடியும் ஒப்பந்தங்கள்", te: "త్వరలో ముగిసే ఒప్పందాలు",
    kn: "ಶೀಘ್ರದಲ್ಲೇ ಮುಗಿಯುವ ಒಪ್ಪಂದಗಳು", gu: "જલ્દી પૂરા થતા કરાર",
    ml: "ഉടൻ അവസാനിക്കുന്ന കരാറുകൾ", pa: "ਜਲਦੀ ਖਤਮ ਹੋ ਰਹੇ ਇਕਰਾਰਨਾਮੇ",
  },
  renewal_days_left: {
    en: "Ends in {n} days", hi: "{n} दिनों में खत्म", mr: "{n} दिवसांत संपेल", bn: "{n} দিনে শেষ",
    ta: "{n} நாட்களில் முடிகிறது", te: "{n} రోజుల్లో ముగుస్తుంది", kn: "{n} ದಿನಗಳಲ್ಲಿ ಮುಗಿಯುತ್ತದೆ",
    gu: "{n} દિવસમાં પૂરું", ml: "{n} ദിവസത്തിൽ അവസാനിക്കും", pa: "{n} ਦਿਨਾਂ ਵਿੱਚ ਖਤਮ",
  },
  renewal_renew: {
    en: "Renew", hi: "नवीनीकरण करें", mr: "नूतनीकरण करा", bn: "নবায়ন করুন",
    ta: "புதுப்பி", te: "పునరుద్ధరించండి", kn: "ನವೀಕರಿಸಿ",
    gu: "નવીકરણ કરો", ml: "പുതുക്കുക", pa: "ਨਵਿਆਓ",
  },
  renewal_relist: {
    en: "Re-list", hi: "फिर से लिस्ट करें", mr: "पुन्हा लिस्ट करा", bn: "আবার তালিকাভুক্ত করুন",
    ta: "மீண்டும் பட்டியலிடு", te: "మళ్లీ జాబితా చేయండి", kn: "ಮತ್ತೆ ಪಟ್ಟಿ ಮಾಡಿ",
    gu: "ફરી લિસ્ટ કરો", ml: "വീണ്ടും ലിസ്റ്റ് ചെയ്യൂ", pa: "ਮੁੜ ਸੂਚੀਬੱਧ ਕਰੋ",
  },
  // K. Boost hot auto-nudge
  boost_hot_title: {
    en: "Interest is hot right now", hi: "अभी रुचि ज़ोरों पर है", mr: "सध्या स्वारस्य जोरात आहे",
    bn: "এখন আগ্রহ তুঙ্গে", ta: "இப்போது ஆர்வம் அதிகம்", te: "ఇప్పుడు ఆసక్తి ఎక్కువగా ఉంది",
    kn: "ಈಗ ಆಸಕ್ತಿ ಜೋರಾಗಿದೆ", gu: "અત્યારે રસ ખૂબ છે",
    ml: "ഇപ്പോൾ താൽപ്പര്യം ഉയർന്നതാണ്", pa: "ਹੁਣੇ ਦਿਲਚਸਪੀ ਸਿਖਰ 'ਤੇ ਹੈ",
  },
  boost_hot_line: {
    en: "{title} has +{n} views since boosting — lock in a tenant before it cools off.",
    hi: "{title} को बूस्ट के बाद +{n} व्यूज़ मिले — ठंडा पड़ने से पहले किराएदार पक्का करें।",
    mr: "{title} ला बूस्टनंतर +{n} व्ह्यूज मिळाले — थंड पडण्याआधी भाडेकरू निश्चित करा.",
    bn: "{title} বুস্টের পর +{n} ভিউ পেয়েছে — ঠান্ডা হওয়ার আগে ভাড়াটে চূড়ান্ত করুন।",
    ta: "{title} பூஸ்ட் செய்த பிறகு +{n} பார்வைகள் — ஆர்வம் குறையும் முன் வாடகைதாரரை உறுதி செய்யுங்கள்.",
    te: "{title}కి బూస్ట్ తర్వాత +{n} వీక్షణలు — ఆసక్తి తగ్గకముందే అద్దెదారును ఖాయం చేసుకోండి.",
    kn: "{title} ಗೆ ಬೂಸ್ಟ್ ನಂತರ +{n} ವೀಕ್ಷಣೆಗಳು — ಆಸಕ್ತಿ ತಣ್ಣಗಾಗುವ ಮೊದಲು ಬಾಡಿಗೆದಾರನನ್ನು ಖಚಿತಪಡಿಸಿ.",
    gu: "{title} ને બૂસ્ટ પછી +{n} વ્યૂ મળ્યા — રસ ઓછો થાય તે પહેલાં ભાડૂત નક્કી કરો.",
    ml: "{title} ന് ബൂസ്റ്റിന് ശേഷം +{n} കാഴ്ചകൾ — താൽപ്പര്യം കുറയുന്നതിന് മുമ്പ് വാടകക്കാരനെ ഉറപ്പിക്കൂ.",
    pa: "{title} ਨੂੰ ਬੂਸਟ ਤੋਂ ਬਾਅਦ +{n} ਵਿਊਜ਼ ਮਿਲੇ — ਠੰਢਾ ਪੈਣ ਤੋਂ ਪਹਿਲਾਂ ਕਿਰਾਏਦਾਰ ਪੱਕਾ ਕਰੋ।",
  },
  boost_hot_cta: {
    en: "Create agreement", hi: "एग्रीमेंट बनाएं", mr: "करार तयार करा", bn: "চুক্তি তৈরি করুন",
    ta: "ஒப்பந்தம் உருவாக்கு", te: "ఒప్పందం సృష్టించండి", kn: "ಒಪ್ಪಂದ ರಚಿಸಿ",
    gu: "કરાર બનાવો", ml: "കരാർ ഉണ്ടാക്കൂ", pa: "ਇਕਰਾਰਨਾਮਾ ਬਣਾਓ",
  },
};

export function pc(lang, key, vars = {}) {
  const entry = COPY[key];
  if (!entry) return key;
  let s = entry[lang] || entry.en;
  Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
  return s;
}

let _cfgCache = null;
export function usePricing() {
  const [config, setConfig] = useState(_cfgCache);
  const [status, setStatus] = useState(null);
  const load = useCallback(async () => {
    try {
      const [c, s] = await Promise.all([
        _cfgCache ? Promise.resolve({ data: _cfgCache }) : api.get("/monetization/config"),
        api.get("/monetization/status"),
      ]);
      _cfgCache = c.data; setConfig(c.data); setStatus(s.data);
    } catch (e) { console.warn("pricing load failed", e); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return { config, status, reload: load };
}

export async function purchase(item, extra = {}) {
  const { data } = await api.post("/monetization/purchase", { item, ...extra });
  return data;
}
